import { routerCollection } from '@constants';
import type { RouteObject } from 'react-router-dom';

import { EntryPage } from './EntryPage';

export const notFoundRouter: RouteObject = {
  path: routerCollection.notFound.root,
  element: <EntryPage />,
};
